<div
  class="notification-ring-container position-relative"
  [matMenuTriggerFor]="notificationsList"
  (menuOpened)="toggleMenu(true)"
  (menuClosed)="toggleMenu(false)"
>
  <app-icon [svg]="EIcon.NOTIFICATIONS" [iconWidth]="24" [iconHeight]="24"></app-icon>

  <div
    *ngIf="unreadCount"
    class="counter-container position-absolute display-flex align-items-center justify-content-center"
  >
    <ng-container [ngTemplateOutlet]="unreadCount > 9 ? trimCounter : defaultCounter"></ng-container>
  </div>
</div>

<ng-template #defaultCounter>
  <div class="label-caps">{{ unreadCount }}</div>
</ng-template>

<ng-template #trimCounter>
  <div class="label-caps">9+</div>
</ng-template>

<mat-menu
  #notificationsList="matMenu"
  class="notification-ring-list-container"
  xPosition="before"
  [classList]="'notification-list'"
  [backdropClass]="'notification-list-backdrop'"
>
  <div
    class="notification-list-content display-flex flex-column"
    (click)="$event.stopPropagation()"
    (keydown.tab)="$event.stopPropagation()"
    (keydown.shift.tab)="$event.stopPropagation()"
  >
    <div class="display-flex justify-content-space-between align-items-center grid-gap-16 list-header">
      <div class="subtitle">Notifications</div>
      <button mat-button color="primary" [disabled]="!unreadCount" (click)="markAllAsRead()">
        <span class="body-small">Mark all as read</span>
      </button>
      <mat-checkbox color="primary" [formControl]="unreadOnly">
        <span class="body-small">show unread only</span>
      </mat-checkbox>
    </div>

    <div class="display-flex flex-column list">
      <ng-container *ngIf="displayedNotificationList.length; else notificationsEmptyList">
        <app-notification-ring-item
          *ngFor="let item of displayedNotificationList; let index = index"
          [notification]="item"
          [isOdd]="index | isOdd"
          (selectEvent)="selectNotification(item)"
          (deleteEvent)="deleteNotification(item)"
          [deleteDisabled]="deleteInProgress$ | async"
        ></app-notification-ring-item>
      </ng-container>
    </div>
  </div>
  <ng-template #notificationsEmptyList>
    <div class="body-small-italic text-centered">No new notifications.</div>
  </ng-template>
</mat-menu>
